import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box, Button } from '@mui/material';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import './header.less';
import AppLogo from '../../../assets/images/cali_logo.png';
import StartNewChat from '../../../assets/images/newChat.png';
import SidebarCollapse from '../../../assets/images/collapse.png';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import { useSelection } from '../../molecules/askAsper/contexts/SelectionContext';
import GenAIIcon from 'assets/svg/GenAi';

// Utility function to extract initials
const getInitials = (name) => {
    if (!name || typeof name !== 'string') return '';

    // Handle email case
    if (name.includes('@')) {
        const localPart = name.split('@')[0];
        const parts = localPart.split('.');
        return parts
            .filter((part) => part.length > 0)
            .map((part) => part[0].toUpperCase())
            .join('')
            .slice(0, 2);
    }

    // Handle full name case
    const words = name.trim().split(/\s+/);
    return words
        .filter((word) => word.length > 0)
        .map((word) => word[0].toUpperCase())
        .join('')
        .slice(0, 2);
};

function Header({ handleReset, resetBtnDisabled, toggleSidebar, sidebarOpen }) {
    const {
        isSelectionMode,
        setIsSelectionMode,
        selectedMessages,
        selectableAIMessages,
        handleSelectAll,
        handleDeselectAll,
    } = useSelection();
    // console.log(isSelectionMode, "--------header", selectedMessages, selectableAIMessages)
    const handleEnterSelectionMode = () => {
        setIsSelectionMode(true);
    };
    // SSO removed: use default display name
    const userName = 'Cali';
    // Then use it to get initials
    const userInitials = getInitials(userName);

    return (
        <AppBar position="static" className="app-header">
            <Toolbar className="relative -top-1">
                <div className="logo-image">
                    <span className="mr-2">
                        <GenAIIcon />
                    </span>
                </div>
                <Typography>
                    <strong>AskAsper</strong>
                </Typography>
                {!sidebarOpen && (
                    <div className="icons-wrapper-left">
                        {/* <IconButton className="appbar-icons-button">
                            <img src={StartNewChat} alt="new-chat" width={15} height={15} />
                        </IconButton> */}
                        <IconButton className="appbar-icons-button" onClick={toggleSidebar}>
                            <img src={SidebarCollapse} alt="collapse" width={15} height={15} />
                        </IconButton>
                    </div>
                )}
                <div className="icons-wrapper">
                    {!isSelectionMode && selectableAIMessages.length > 0 && (
                        <IconButton
                            className="appbar-icons-button"
                            disabled={isSelectionMode}
                            sx={{
                                color: resetBtnDisabled ? '#5D5D5D66' : '#000000',
                                // textTransform: 'none',
                                // backgroundColor: '#b1c2f2',
                                // color: '#fff',
                                // fontSize: '14px',
                                // borderRadius: '16px',
                                // borderColor: '#b1c2f2',
                                // '&:hover': {
                                //   backgroundColor: '#9fb0f0',
                                //   borderColor: '#9fb0f0',
                                // },
                            }}
                            title={'select messages'}
                            onClick={handleEnterSelectionMode}
                        >
                            <SelectAllIcon />
                        </IconButton>
                    )}
                    {isSelectionMode && (
                        <IconButton
                            className="appbar-icons-button"
                            title={
                                selectedMessages.size === selectableAIMessages.length ? 'Deselect All' : 'Select All'
                            }
                            onClick={
                                selectedMessages.size === selectableAIMessages.length
                                    ? handleDeselectAll
                                    : handleSelectAll
                            }
                        >
                            {selectedMessages.size === selectableAIMessages.length ? (
                                <DeselectIcon />
                            ) : (
                                <SelectAllIcon />
                            )}
                        </IconButton>
                    )}

                    {/* <IconButton
                        className="appbar-icons-button"
                        sx={{ color: resetBtnDisabled ? '#5D5D5D66' : '#000000' }}
                        disabled={resetBtnDisabled}
                        onClick={() => handleReset(true)}
                    >
                        <RestartAltOutlinedIcon />
                    </IconButton> */}
                    {/* <IconButton className="appbar-icons-button">
                        <FileDownloadOutlinedIcon className="appbar-icons" />
                    </IconButton> */}
                    {/* <span className="pipe"></span>
                    <div className="user-initials">{userInitials}</div> */}
                </div>
            </Toolbar>
        </AppBar>
    );
}

export default Header;
